import { createReducer } from "reduxsauce";

import UIDs from "../../../UIDs";
import _ from "lodash";
import ReducerRegister from "../../ReducerRegister";
import { ActionTypes } from "../../actionTypes/screens/studyletter/PracticeActionTypes";
import { ActionTypes as RecordSettingActionTypes } from "../../actionTypes/screens/course/RecordSettingActionTypes";
import PracticeService from "../../../services/screens/studyletter/PracticeService";
import AsyncActionReducers from "../../AsyncActionReducers";
import LetterStateManager from "../../../utils/LetterStateManager";

const calcEndedUnitCount = data => {
    const { units } = data;
    return _.filter(units, s => s.endOn).length;
};

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (letter) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            PracticeService.loadScreenView(
                letter,
                response => {
                    LetterStateManager.instance().updateData(response.updatedLetters);
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    loadPracticeResultAsync: (vo) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_PRACTICE_RESULT_ASYNC });

            setTimeout(() => {
                dispatch(Actions.loadPracticeResultSuccess(vo));
            }, 0);
        };
    },

    loadPracticeResultSuccess: data => ({
        type: ActionTypes.LOAD_PRACTICE_RESULT_SUCCESS,
        parentType: ActionTypes.LOAD_PRACTICE_RESULT_ASYNC,
        postReducer: loadPracticeResultSuccessPostReducer,
        data
    }),

    loadPracticeResultFailure: error => ({
        type: ActionTypes.LOAD_PRACTICE_RESULT_FAILURE,
        parentType: ActionTypes.LOAD_PRACTICE_RESULT_ASYNC,
        error
    }),

    showFooter: val => ({
        type: ActionTypes.SHOW_FOOTER,
        val,
    }),

    showCommonModalRef: val => ({
        type: ActionTypes.SHOW_COMMON_MODAL_REF,
        val,
    }),

    reportResult: (result, needReport) => ({
        type: ActionTypes.REPORT_RESULT,
        result,
        needReport
    }),

    nextUnit: () => ({
        type: ActionTypes.NEXT_UNIT,
    }),

    updateLocalResultAsync: vo => {
        return (dispatch, getState) => {
            dispatch({ type: ActionTypes.UPDATE_LOCAL_RESULT_ASYNC });

            setTimeout(() => {
                dispatch(Actions.updateLocalResultSuccess(vo));
            }, 0);
        };
    },

    updateLocalResultSuccess: (vo) => ({
        type: ActionTypes.UPDATE_LOCAL_RESULT_SUCCESS,
        parentType: ActionTypes.UPDATE_LOCAL_RESULT_ASYNC,
        postReducer: updateLocalResultSuccessReducer,
        data: vo,
        vo,
    }),

    updateLocalResultFailure: error => ({
        type: ActionTypes.UPDATE_LOCAL_RESULT_FAILURE,
        parentType: ActionTypes.UPDATE_LOCAL_RESULT_ASYNC,
        postReducer: updateLocalResultErrorReducer,
        error,
    }),

    updateUnitResultAsync: vo => {
        return (dispatch, getState) => {
            dispatch({ type: ActionTypes.UPDATE_UNIT_RESULT_ASYNC });

            PracticeService.updateUnitResult(
                vo,
                response => {
                    dispatch(Actions.updateUnitResultSuccess(response, vo));
                },
                error => {
                    dispatch(Actions.updateUnitResultFailure(error));
                }
            );
        };
    },

    updateUnitResultSuccess: (data, vo) => ({
        type: ActionTypes.UPDATE_UNIT_RESULT_SUCCESS,
        parentType: ActionTypes.UPDATE_UNIT_RESULT_ASYNC,
        postReducer: null,
        vo,
    }),

    updateUnitResultFailure: error => ({
        type: ActionTypes.UPDATE_UNIT_RESULT_FAILURE,
        parentType: ActionTypes.UPDATE_UNIT_RESULT_ASYNC,
        postReducer: null,
        error,
    }),

    updateSettings: settings => ({
        type: ActionTypes.UPDATE_SETTINGS,
        settings
    }),

    showPracticeResult: val => ({
        type: ActionTypes.SHOW_PRACTICE_RESULT,
        val
    }),

    restartAsync: vo => {
        return (dispatch, /* getState */) => {
            dispatch({ type: ActionTypes.RESTART_ASYNC });

            PracticeService.restart(
                vo,
                response => {
                    dispatch(Actions.restartSuccess(response, vo));
                },
                error => {
                    dispatch(Actions.restartFailure(error));
                }
            );
        };
    },

    restartSuccess: (data, { unitId }) => ({
        type: ActionTypes.RESTART_ASYNC_SUCCESS,
        parentType: ActionTypes.RESTART_ASYNC,
        postReducer: restartSuccessReducer,
        data,
        unitId
    }),

    restartFailure: error => ({
        type: ActionTypes.RESTART_ASYNC_FAILURE,
        parentType: ActionTypes.RESTART_ASYNC,
        error,
    }),

    completeAsync: vo => {
        return (dispatch, /* getState */) => {
            dispatch({ type: ActionTypes.COMPLETE_ASYNC });

            PracticeService.complete(
                vo,
                response => {
                    LetterStateManager.instance().updateData(response.updatedLetters);
                    dispatch(Actions.completeSuccess(response));
                },
                error => {
                    dispatch(Actions.completeFailure(error));
                }
            );
        };
    },

    completeSuccess: (data) => ({
        type: ActionTypes.COMPLETE_ASYNC_SUCCESS,
        parentType: ActionTypes.COMPLETE_ASYNC,
        data,
    }),

    completeFailure: error => ({
        type: ActionTypes.COMPLETE_ASYNC_FAILURE,
        parentType: ActionTypes.COMPLETE_ASYNC,
        error,
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    units: [],
    unitResults: [],
    showFooter: false,
    showCommonModalRef: false,
    startOn: null,
    pageIndex: null,
    unitResult: null,
    passingScore: 100,
    averageScore: 0,
    letterScores: [],
    endedUnitCount: null,
    totalCount: 0,
    errorCount: 0,
    totalTime: 0,
    settings: {
        pinyinVisible: true,
        translationVisible: true,
        answerVisible: false,
        useLocalFilePath: false,
        talkChinese: true,
        recording: {
            showPinYin: 1,
            showTranslate: 0,
            playExample: 0,
            continuousPlay: 1,
            fixedLevel: false,
            autoStart: true,
        },
        localizeTitle: true,     //true 按用户本地语言来显示title  false或不存在就显示中文
    },
    speechRecognitionSettings: {
        aliYunToken: {
            token: "",
            expireTime: 0,
        },
        aliYunIntToken: {
            token: "",
            expireTime: 0,
        },
    },
    showPracticeResult: false,
    isReporting: false,
    dialogCount: 0,
    wordsCount: 0,
    data: null,
    result: null,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    const { units, passingScore } = data;

    for (let i = 0; i < units.length; ++i) {
        if (_.isString(units[i].data)) {
            units[i].data = JSON.parse(units[i].data);
        }
    }

    let pageIndex = units.findIndex(u => !u.endOn);
    const endedUnitCount = calcEndedUnitCount({ units: units });
    return {
        ...state,
        units,
        unitResults: [],
        passingScore,
        showFooter: false,
        showCommonModalRef: false,
        pageIndex: pageIndex,
        startOn: new Date().getTime(),
        unitResult: null,
        totalUnitCount: units.length,
        endedUnitCount,
        showPracticeResult: false,
        settings: { ...state.settings, useLocalFilePath: data.useLocalFilePath || false, recording: data.recordConfig ? {...state.settings.recording, ...data.recordConfig} : state.settings.recording },
        speechRecognitionSettings: { ...state.speechRecognitionSettings, aliYunToken: data.aliYunToken, aliYunIntToken: data.aliYunIntToken },
    };
};

const buildData = (unit, practiceRole) => {
    const { id, unitType = "", score, data: unitData, answer, files, totalScore, rank, useState, vipEnabled } = unit;

    let data = { unitType, ...unitData, id, totalScore, rank, useState, vipEnabled: true };
    let result = { score, answer: JSON.parse(answer || null), files: JSON.parse(files || null) };

    if (data.singleUnits) {
        let singleData = data.singleUnits[data.childUnitIndex || 0];
        singleData.practiceRole = practiceRole;
        data = { ...data, ...singleData };
    }

    return { data, result };
};

const loadPracticeResultSuccessPostReducer = (state, { data }) => {
    const { units, unitResults } = state;
    const { letter, pageIndex, result, practiceRole } = data;
    const unit = {...units[pageIndex], ...unitResults[pageIndex]};
    return {
        ...state,
        ...buildData(unit, practiceRole),
        result
    };
};

const showFooterReducer = (state, { val }) => {
    return { ...state, showFooter: val };
};

const showCommonModalRefReducer = (state, { val }) => {
    return { ...state, showCommonModalRef: val };
};

const reportResultReducer = (state, { result, needReport }) => {
    return { ...state, unitResult: { ...result, startOn: state.startOn, endOn: new Date().getTime() }, isReporting: needReport };
};

const nextUnitReducer = (state, { }) => {
    let settings = state.settings;
    let units = state.units;
    let pageIndex = state.pageIndex;

    //find the first not complete unit
    //从当前pageIndex下一个开始往后面找；如果找不到，在从头开始找
    let nextIndex = _.findIndex(units, u => !u.endOn, pageIndex + 1);
    if (nextIndex === -1) {
        nextIndex = units.findIndex(u => !u.endOn);
    }

    pageIndex = nextIndex;

    return { ...state, pageIndex, startOn: new Date().getTime(), showFooter: false, showCommonModalRef: false, showPracticeResult: false, settings: { ...settings, recording: { ...state.settings.recording } } };
};

const updateSettingsReducer = (state, { settings }) => {
    return { ...state, settings };
};

const saveRecordSettingSuccessPostReducer = (state, { data }) => {
    return {
        ...state,
        settings: { ...state.settings, recording: { ...state.settings.recording, ...data } },
    };
};

const updateLocalResultSuccessReducer = (state, { vo }) => {
    const { units, unitResults, pageIndex } = state;
    let newUnits = _.clone(units);
    let newResults = _.clone(unitResults);
    if (newUnits[pageIndex]) {
        newUnits[pageIndex].score = vo.score;
        if (vo.startOn) {
            newUnits[pageIndex].startOn = vo.startOn;
        }
        if (vo.endOn) {
            newUnits[pageIndex].endOn = vo.endOn;
        }
        newUnits[pageIndex].timeCost = vo.timeCost;
        newUnits[pageIndex].reportResultDone = true;
        newResults[pageIndex] = vo;
    }

    const endedUnitCount = calcEndedUnitCount({ units: newUnits });
    return { ...state, units: newUnits, unitResults: newResults, endedUnitCount, isReporting: false };
}

const updateLocalResultErrorReducer = (state) => {
    return { ...state, isReporting: false };
}

const showPracticeResultReducer = (state, { val }) => {
    return { ...state, showPracticeResult: val }
}

const restartSuccessReducer = (state, { unitId }) => {
    const { units, unitResults, pageIndex } = state;
    let newUnits = _.clone(units);
    let newResults = _.clone(unitResults);
    if (newUnits[pageIndex]) {
        newResults[pageIndex] = null;

        let unit = _.cloneDeep(newUnits[pageIndex]);
        unit.reportResultDone = false;
        unit.endOn = null;
        newUnits[pageIndex] = unit;
    }
    return { ...state, units: newUnits, unitResults: newResults, isReporting: false,
             showPracticeResult: false, showFooter: false, showCommonModalRef: false};
}

const completeSuccessPostReducer = (state, { data }) => {
    const { averageScore, letterScores, totalCount, errorCount, totalTime } = data;
    return {
        ...state,
        averageScore,
        letterScores,
        totalCount,
        errorCount,
        totalTime,
    };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LOAD_PRACTICE_RESULT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_PRACTICE_RESULT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_PRACTICE_RESULT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.REPORT_RESULT]: reportResultReducer,
    [ActionTypes.SHOW_FOOTER]: showFooterReducer,
    [ActionTypes.SHOW_COMMON_MODAL_REF]: showCommonModalRefReducer,
    [ActionTypes.NEXT_UNIT]: nextUnitReducer,
    [ActionTypes.UPDATE_LOCAL_RESULT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPDATE_LOCAL_RESULT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPDATE_LOCAL_RESULT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_UNIT_RESULT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPDATE_UNIT_RESULT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPDATE_UNIT_RESULT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_SETTINGS]: updateSettingsReducer,
    [RecordSettingActionTypes.SAVE_RECORD_SETTING_SUCCESS]: saveRecordSettingSuccessPostReducer,
    [ActionTypes.SHOW_PRACTICE_RESULT]: showPracticeResultReducer,
    [ActionTypes.RESTART_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.RESTART_ASYNC_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.RESTART_ASYNC_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.COMPLETE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.COMPLETE_ASYNC_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.COMPLETE_ASYNC_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.screens.studyletter.practice, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
